import React from "react";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import moment from "moment";
import { startCase, truncate } from "lodash";

type Props = {
  exportPDF?: any;
};

const CommoditiesPDF = (props: Props) => {
  const { exportPDF } = props;

  return (
    <Document>
      <Page style={styles.body}>
        <View
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            backgroundColor: "#22c35e",
            padding: 10,
            letterSpacing: 10,
          }}
        >
          <Text style={styles.logo}>FREESHU</Text>
        </View>
        <View style={{ border: 1, margin: 20 }}>
          <View style={styles.header}>
            <Text style={styles.headerText}>Name</Text>
            <Text style={styles.headerText}>Owner</Text>
            <Text style={styles.headerText}>Retail</Text>
            <Text style={styles.headerText}>Updated</Text>
            <Text style={styles.headerText}>Whole Sale</Text>
            <Text style={styles.headerText}>Updated</Text>
          </View>
          {exportPDF.map((item: any) => (
            <View style={styles.row} key={item.id}>
              <Text style={styles.rowText}>
                {truncate(item?.name || "", {
                  length: 50,
                })}
              </Text>
              <Text style={styles.rowText}>
                {startCase(item?.user?.establishment || item?.user?.name)}
              </Text>
              <Text style={styles.rowText}>
                {item?.retailPrices[0]?.price
                  ? `${item?.retailPrices[0]?.price} / ${item.measurementUnit}`
                  : "n/a"}
              </Text>
              <Text style={styles.rowText}>
                {item?.retailPrices[0]?.price
                  ? moment(item.retailPrices[0]?.createdAt).format(
                      "MMM. D, Y, h:mm a"
                    )
                  : "n/a"}
              </Text>
              <Text style={styles.rowText}>
                {item?.wholeSalePrices[0]?.price
                  ? `${item?.wholeSalePrices[0]?.price} / ${item.measurementUnit}`
                  : "n/a"}
              </Text>
              <Text style={styles.rowText}>
                {item?.wholeSalePrices[0]?.price
                  ? moment(item.wholeSalePrices[0]?.createdAt).format(
                      "MMM. D, Y, h:mm a"
                    )
                  : "n/a"}
              </Text>
            </View>
          ))}
        </View>
        <View
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            backgroundColor: "#CBD5E0",
            padding: 10,
            position: "absolute",
            bottom: 0,
            width: "100%",
          }}
        >
          <Text
            style={{
              color: "#718096",
              textAlign: "center",
              fontSize: 12,
            }}
          >
            {moment().format("LLLL")}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

const styles = StyleSheet.create({
  body: {},
  logo: {
    fontSize: 15,
    color: "white",
    fontWeight: "bold",
  },
  header: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    alignContent: "flex-start",
    background: "grey",
    borderBottom: 1,
    padding: 8,
    borderBottomColor: "#4A5568",
  },
  headerText: {
    fontSize: 10,
    flex: 1,
  },
  row: {
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "row",
    padding: 8,
    borderBottomColor: "#4A5568",
    borderBottom: 1,
  },
  rowText: {
    fontSize: 8,
    flex: 1,
    color: "#4A5568",
  },
});
export default CommoditiesPDF;
